import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';

const ImplicitTermsAndConditionsContainer = ()=>{
    const { consent  } = useCheckoutSettings();
    const { getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            disclaimerCondition: getFormattedLabel('checkout.disclaimer.conditions', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getFormattedLabel
    ]);
    if (!(consent === null || consent === void 0 ? void 0 : consent.implicitTermsAndConditions)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Text, {
        className: "checkout-step__terms-and-conditions"
    }, labels.disclaimerCondition);
};

export { ImplicitTermsAndConditionsContainer };
//# sourceMappingURL=ImplicitTermsAndConditionsContainer.js.map
